export type InstitutionRow = {
  id: number;
  createdAt: string;
  updatedAt: string;
  state: 'NORMAL' | 'DELETED';
  name: string;
  code: string;
  imageUrl: string | null;
};

export const mockInstitutions: InstitutionRow[] = [
  {
    id: 1,
    createdAt: '2024-01-10T02:30:15.123456Z',
    updatedAt: '2025-03-01T08:12:40.654321Z',
    state: 'NORMAL',
    name: '서울대학교',
    code: 'SNU',
    imageUrl: 'https://picsum.photos/seed/inst-snu/200/200',
  },
  {
    id: 2,
    createdAt: '2024-01-11T04:15:22.123456Z',
    updatedAt: '2025-02-28T11:05:03.654321Z',
    state: 'NORMAL',
    name: '연세대학교',
    code: 'YONSEI',
    imageUrl: 'https://picsum.photos/seed/inst-yonsei/200/200',
  },
  {
    id: 3,
    createdAt: '2024-01-15T06:45:09.123456Z',
    updatedAt: '2025-04-02T09:22:18.654321Z',
    state: 'NORMAL',
    name: '고려대학교',
    code: 'KOREA',
    imageUrl: null,
  },
  {
    id: 4,
    createdAt: '2024-02-01T01:20:44.123456Z',
    updatedAt: '2025-01-18T14:40:55.654321Z',
    state: 'NORMAL',
    name: '한국과학기술원',
    code: 'KAIST',
    imageUrl: 'https://picsum.photos/seed/inst-kaist/200/200',
  },
  {
    id: 5,
    createdAt: '2024-02-05T03:08:31.123456Z',
    updatedAt: '2024-12-20T16:33:12.654321Z',
    state: 'NORMAL',
    name: '포항공과대학교',
    code: 'POSTECH',
    imageUrl: null,
  },
  {
    id: 6,
    createdAt: '2024-02-20T07:55:00.123456Z',
    updatedAt: '2025-03-15T10:18:27.654321Z',
    state: 'NORMAL',
    name: '성균관대학교',
    code: 'SKKU',
    imageUrl: 'https://picsum.photos/seed/inst-skku/200/200',
  },
  {
    id: 7,
    createdAt: '2024-03-01T09:12:48.123456Z',
    updatedAt: '2025-02-10T12:00:01.654321Z',
    state: 'NORMAL',
    name: '한양대학교',
    code: 'HANYANG',
    imageUrl: null,
  },
  {
    id: 8,
    createdAt: '2024-03-12T05:40:19.123456Z',
    updatedAt: '2025-04-28T07:45:22.654321Z',
    state: 'NORMAL',
    name: '이화여자대학교',
    code: 'EWHA',
    imageUrl: 'https://picsum.photos/seed/inst-ewha/200/200',
  },
  {
    id: 9,
    createdAt: '2024-04-01T08:22:33.123456Z',
    updatedAt: '2025-01-05T13:11:44.654321Z',
    state: 'NORMAL',
    name: '서강대학교',
    code: 'SOGANG',
    imageUrl: null,
  },
  {
    id: 10,
    createdAt: '2024-04-18T02:18:07.123456Z',
    updatedAt: '2025-03-22T15:27:09.654321Z',
    state: 'NORMAL',
    name: '중앙대학교',
    code: 'CAU',
    imageUrl: 'https://picsum.photos/seed/inst-cau/200/200',
  },
  {
    id: 11,
    createdAt: '2023-11-01T10:00:00.123456Z',
    updatedAt: '2024-08-30T18:00:00.654321Z',
    state: 'DELETED',
    name: '숭실대학교 (삭제됨)',
    code: 'SSU',
    imageUrl: null,
  },
];
